module.exports = "<div class=loader [ngClass]=appearance *ngFor=\"let number of numbers\"></div> ";